import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { configureAppStore } from './redux/store';
import reportWebVitals from './reportWebVitals';
import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
  concat
} from '@apollo/client';
import { PersistGate } from 'redux-persist/integration/react';

const { store, persistor } = configureAppStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL_URL });

const token = localStorage.getItem('token') ?? 'token';

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(
    ({
      headers = {
        'x-api-key': process.env.REACT_APP_GRAPHQL_API_KEY
      }
    }) => ({
      headers: {
        ...headers,
        authorization: `Bearer ${token}`
      }
    })
  );

  return forward(operation);
});

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink)
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ApolloProvider client={client}>
          <App />
        </ApolloProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
